// Review header: row/match/error/warning counts + colour legend.

import { useTranslation } from 'react-i18next';

export function SummaryBar({
  rowCount,
  autoMatched,
  needsPick,
  errors,
  warnings,
}: {
  rowCount: number;
  autoMatched: number;
  needsPick: number;
  errors: number;
  warnings: number;
}) {
  const { t } = useTranslation('inventory-import');
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span className="rounded-md bg-neut-100 px-2 py-1 font-medium text-neut-prim">
        {t('summary.rows', { count: rowCount })}
      </span>
      <span className="rounded-md bg-success-100 px-2 py-1 font-medium text-success-700">
        {t('summary.auto_matched', { count: autoMatched })}
      </span>
      <span className="rounded-md bg-warning-100 px-2 py-1 font-medium text-warning-600">
        {t('summary.needs_pick', { count: needsPick })}
      </span>
      <span className="rounded-md bg-error-100 px-2 py-1 font-medium text-error-600">
        {t('summary.errors', { count: errors })}
      </span>
      <span className="rounded-md bg-neut-100 px-2 py-1 font-medium text-neut-sec">
        {t('summary.warnings', { count: warnings })}
      </span>
      <span className="ml-2 flex items-center gap-1 text-xs text-neut-sec">
        <span className="inline-block h-3 w-3 rounded-sm bg-error-100" />{' '}
        {t('summary.legend_error')}
        <span className="ml-2 inline-block h-3 w-3 rounded-sm bg-warning-100" />{' '}
        {t('summary.legend_warning')}
      </span>
    </div>
  );
}
